export const companyInfo = {
  name: "Brønshøj Ure og Guld",
  address: "Frederikssundsvej 306A",
  zipCity: "2700 Brønshøj",
  phone: "38 28 10 74",
  phoneRaw: "38281074",
  email: "info@ureogguld.dk",
  cvr: "26995396",
  instagramUrl: "https://www.instagram.com/ure_og_guld",
  facebookUrl: "https://www.facebook.com/UreOgGuld/",
  logoUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/elegant-black-and-white-logo-design-5.png",
  logoWhiteUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/elegant-black-and-white-logo-design-2.png",
};

export const openingHours = [
  { day: "Mandag", hours: "10:00 – 17:15" },
  { day: "Tirsdag", hours: "10:00 – 17:15" },
  { day: "Onsdag", hours: "10:00 – 17:15" },
  { day: "Torsdag", hours: "10:00 – 17:15" },
  { day: "Fredag", hours: "10:00 – 17:15" },
  { day: "Lørdag", hours: "LUKKET" },
  { day: "Søndag", hours: "LUKKET" },
];

export const navigationLinks = [
  { label: "Forside", href: "/" },
  { label: "Vi køber guld & sølv", href: "/vi-koeber-guld-og-soelv", isPrimary: true },
  {
    label: "Vores Værksted & Service",
    href: "/guldsmedevaerksted",
    dropdown: [
      { label: "Guldsmedeværksted", href: "/guldsmedevaerksted" },
      { label: "Smykker efter eget design", href: "/smykker-eget-design" },
      { label: "Urereparation", href: "/urereparation" },
    ]
  },
  { label: "Brands", href: "/brands" },
  { label: "Om os", href: "/om-os" },
  { label: "Inspiration", href: "/inspiration" },
  { label: "Kontakt", href: "/kontakt" },
];

export const instagramPosts = [
  {
    id: "1",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-137-639989608-2046706026108778-3908745731602171548-n.jpg",
    caption: "Classic by Nuran ✨ Vielsesringe med brillantslebne diamanter i 14kt rød-, hvid- og rosaguld.",
    likes: 42,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "2",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-113-641681091-2048567015922679-1442163617195137540-n.jpg",
    caption: "Unikt håndværk fra eget guldsmedeværksted i Brønshøj. Vi skaber smykker efter dine drømme.",
    likes: 58,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "3",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-770724535-2201547897291256-6216673389701746578-n.jpg",
    caption: "Smukke Grace ringe fra Nuran med farvede ædelsten og brillanter.",
    likes: 36,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "4",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-767222368-2201547903957922-6641466863669271029-n.jpg",
    caption: "Glimt fra værkstedet: Lodning, reparation og tilpasning af ringstørrelser.",
    likes: 64,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "5",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762916558-2190988508347195-957866742761152989-n.jpg",
    caption: "Præcision i hver detalje. Vores guldsmede arbejder med passion og omhu.",
    likes: 49,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "6",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762553405-2193861241393255-5759380788054099571-n.jpg",
    caption: "Urereparation i Brønshøj. Vi tilbyder batteriskift, trykprøvning og fuld urværksservice.",
    likes: 52,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "7",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-759999170-2190988511680528-8262510330018174778-n.jpg",
    caption: "Eksklusive diamanter fattet i 14 karat guld på vort eget værksted i Brønshøj.",
    likes: 41,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "8",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-758809167-2188117461967633-3051322944976904849-n.jpg",
    caption: "Specialfremstillet unika ring skabt ud fra kundens eget arveguld.",
    likes: 67,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "9",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-739309432-2168239040622142-5660170901530522428-n.jpg",
    caption: "Finpudsning af smykker og ure i forretningen på Frederikssundsvej.",
    likes: 38,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "10",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-720066351-2143641243081922-8224567293673391329-n.jpg",
    caption: "Kvalitetsarbejde på værkstedet. Vi værner om det gode traditionelle fag.",
    likes: 55,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "11",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-678357230-2096232131156167-6877237663801722109-n.jpg",
    caption: "Glimt fra vores udstilling med klassiske smykker og nyeste kollektioner.",
    likes: 47,
    link: "https://www.instagram.com/ure_og_guld"
  },
  {
    id: "12",
    imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-2-481298064-1727183571394360-5526875855528673094-n.jpg",
    caption: "Velkommen hos Brønshøj Ure & Guld. Vi glæder os til at rådgive dig i butikken.",
    likes: 73,
    link: "https://www.instagram.com/ure_og_guld"
  }
];

export const galleriesData = {
  "egne-smykker": [
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-137-639989608-2046706026108778-3908745731602171548-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-113-641681091-2048567015922679-1442163617195137540-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-770724535-2201547897291256-6216673389701746578-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-767222368-2201547903957922-6641466863669271029-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-767222368-2201547903957922-6641466863669271029-n-1.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762916558-2190988508347195-957866742761152989-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762553405-2193861241393255-5759380788054099571-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-761596628-2193861244726588-4858289997941447473-n.jpg"
  ],
  "specialdesign": [
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-759999170-2190988511680528-8262510330018174778-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-759965034-2190988518347194-5687187683790867377-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-758809167-2188117461967633-3051322944976904849-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-753695054-2183587262420653-6137485461556631979-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-752484625-2183587252420654-910436434715108786-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-749056519-2178237346288978-7575095009079936217-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-747191142-2176417093137670-1059447462481146502-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-747145854-2176417076471005-7744944367291734385-n.jpg"
  ],
  "ure": [
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-739309432-2168239040622142-5660170901530522428-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-734522051-2163427747769938-2788574082596850356-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-730451678-2158740401572006-2434670711110015067-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-727543335-2154825598630153-1848563629823668549-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-726516337-2154825575296822-6184443906550520482-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-723820292-2145591626220217-2076347084613686011-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-723714231-2148352795944100-8096788204024830556-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-723706699-2148352799277433-9124619905795375301-n.jpg"
  ],
  "guldsmedevaerksted": [
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-720066351-2143641243081922-8224567293673391329-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-718675500-2145591222886924-7835885684845522401-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-710738197-2130808224365224-1320070232778293669-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-710555756-2134778763968170-5335953566554388536-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-710423404-2130808221031891-434625461031147765-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-710059146-2130808217698558-1145146283944205239-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-707349018-2128017974644249-3857074074480054101-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-691259830-2111687916277255-229202910115914980-n.jpg"
  ],
  "butikken": [
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-678357230-2096232131156167-6877237663801722109-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-656199755-2071687166943997-4842321265746240779-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-654868285-2071687183610662-3515381818335373868-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-653707600-2065960247516689-398339568453468473-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-649241720-2059928318119882-5835155399031424417-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-645308290-2053203362125711-8357036613656816799-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-645225012-2053203382125709-4747771885488867883-n.jpg",
    "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-2-481298064-1727183571394360-5526875855528673094-n.jpg"
  ]
};

export const brandsData = [
  // Smykker
  {
    name: "NURAN",
    category: "smykker",
    active: true,
    description: "Eksklusive danske guld- og diamantsmykker"
  },
  {
    name: "NURAN Wedding",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/wedding-by-nuran.png"],
    description: "Vielsesringe og forlovelsesringe i højeste kvalitet"
  },
  {
    name: "Eget Design & Direkte Import",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/logo-trans.png"],
    subtitle: "Eget Værksted & Egen Import",
    description: "Hos Ure & Guld designer og fremstiller vi egne smykker og importerer direkte",
    link: "/smykker-eget-design",
    isOwnWorkshop: true
  },
  {
    name: "Melfia",
    category: "smykker",
    active: true,
    description: "Moderne og tidløse smykkedesigns"
  },
  {
    name: "Aqua Dulce",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/aqua-dulca.png"],
    description: "Feminine smykker i ægte sterlingsølv og forgyldt sølv"
  },
  {
    name: "Lund Copenhagen",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/lund-copenhagen.png"],
    description: "Klassisk dansk guldsmedekunst og margueritter siden 1858"
  },
  {
    name: "Siersbøl",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/siersboel.webp"],
    description: "Tidløse og elegante smykker i ædle metaller"
  },
  {
    name: "Son Of Noa",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/son-of-noa.jpg"],
    description: "Maskuline smykker til mænd i stål, sølv og læder"
  },
  {
    name: "Joanli Nor",
    category: "smykker",
    active: true,
    description: "Elegante sølvsmykker besat med funklende zirkoner"
  },
  {
    name: "L&G Smykker",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/l-and-g.png"],
    description: "Kvalitetssmykker i guld og sølv"
  },
  {
    name: "G&S Design",
    category: "smykker",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/guld-og-soelv-design.png"],
    description: "Guld & Sølv Design klassikere"
  },
  {
    name: "Noa Kids Jewellery",
    category: "smykker",
    active: true,
    description: "Fine og fantasifulde smykker skabt til børn"
  },
  {
    name: "Zilverstad",
    category: "smykker",
    active: true,
    description: "Klassiske dåbsgaver, sparebøsser, rasler og mindegaver"
  },
  {
    name: "Hagerty Smykkepleje",
    category: "smykker",
    active: true,
    description: "Professionelle rense- og plejeprodukter til guld, sølv og perler"
  },
  {
    name: "Smykker Med Historie",
    category: "smykker",
    active: true,
    description: "Personlige og symbolske smykker med sjæl"
  },

  // Ure
  {
    name: "Jaguar",
    category: "ure",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/jaguar.png"],
    description: "Schweizisk urmagerpræcision og eksklusivt design"
  },
  {
    name: "Festina",
    category: "ure",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/festina.png"],
    description: "Klassiske kronografer og sporty kvalitetsure"
  },
  {
    name: "CITIZEN",
    category: "ure",
    active: true,
    description: "Avanceret japansk teknologi med lysdrevet Eco-Drive"
  },
  {
    name: "DKNY",
    category: "ure",
    active: true,
    description: "Ikoniske og stilfulde New York modeure"
  },
  {
    name: "Obaku",
    category: "ure",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/obaku.webp"],
    description: "Dansk minimalistisk ro og æstetisk design i stål og titan"
  },
  {
    name: "Boccia Titanium",
    category: "ure",
    active: true,
    description: "Allergivenlige og fjerlette ure fremstillet i titanium"
  },
  {
    name: "Bonett",
    category: "ure",
    active: true,
    description: "Danskdesignede kvalitetsure"
  },
  {
    name: "Hot Shot børneure",
    category: "ure",
    active: true,
    logo_url: ["https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/hot-shot.png"],
    description: "Tydelige, vandtætte og holdbare kvalitetsure til børn"
  },
  {
    name: "Vægure & Vækkeure",
    category: "ure",
    active: true,
    description: "Pålidelige vækkeure og dekorative vægure til ethvert hjem"
  }
];

